import styled from 'styled-components';

export const TableMainLabel = styled.div`
  font-size: 14px;
  font-weight: bold;
`;

export const TableSubLabel = styled.div`
  font-size: 12px;
  opacity: 0.6;
`;
